//
import {
  CONTRIBUYENTES_SET_RESPONSE_PARAMETROS,
  CONTRIBUYENTES_UNSET_ERROR,
  CONTRIBUYENTES_UNSET_MENSAJE_EXITO,
  CONTRIBUYENTES_GET_LISTA,
  CONTRIBUYENTES_GET_LISTA_SUCCESS,
  CONTRIBUYENTES_GET_LISTA_FAIL,
  CONTRIBUYENTES_GET_OPTIONS,
  CONTRIBUYENTES_GET_OPTIONS_SUCCESS,
  CONTRIBUYENTES_GET_OPTIONS_FAIL,
  CONTRIBUYENTES_GET_BUSQUEDA,
  CONTRIBUYENTES_GET_BUSQUEDA_SUCCESS,
  CONTRIBUYENTES_GET_BUSQUEDA_FAIL,
  CONTRIBUYENTES_POST_CREATE,
  CONTRIBUYENTES_POST_CREATE_SUCCESS,
  CONTRIBUYENTES_POST_CREATE_FAIL,
  CONTRIBUYENTES_PUT_UPDATE,
  CONTRIBUYENTES_PUT_UPDATE_SUCCESS,
  CONTRIBUYENTES_PUT_UPDATE_FAIL,
  CONTRIBUYENTES_DEL_DELETE,
  CONTRIBUYENTES_DEL_DELETE_SUCCESS,
  CONTRIBUYENTES_DEL_DELETE_FAIL,
} from "./actionTypes"

// Para poner mensajes exitosos
export const setContribuyentesResponseParametros = parameters => ({
  type: CONTRIBUYENTES_SET_RESPONSE_PARAMETROS,
  payload: { parameters },
})

// Quitar el mensaje Exito
export const unsetContribuyentesError = () => ({
  type: CONTRIBUYENTES_UNSET_ERROR,
})

// Quitar el mensaje Exito
export const unsetContribuyentesMensajeExito = () => ({
  type: CONTRIBUYENTES_UNSET_MENSAJE_EXITO,
})

export const getContribuyentesLista = jsonparameters => ({
  type: CONTRIBUYENTES_GET_LISTA,
  payload: { jsonparameters },
})
export const getContribuyentesListaSuccess = data => ({
  type: CONTRIBUYENTES_GET_LISTA_SUCCESS,
  payload: { data },
})
export const getContribuyentesListaFail = error => ({
  type: CONTRIBUYENTES_GET_LISTA_FAIL,
  payload: error,
})

export const getContribuyentesOptions = jsonparameters => ({
  type: CONTRIBUYENTES_GET_OPTIONS,
  payload: { jsonparameters },
})
export const getContribuyentesOptionsSuccess = data => ({
  type: CONTRIBUYENTES_GET_OPTIONS_SUCCESS,
  payload: { data },
})
export const getContribuyentesOptionsFail = error => ({
  type: CONTRIBUYENTES_GET_OPTIONS_FAIL,
  payload: error,
})

export const getContribuyentesBusqueda = jsonparameters => ({
  type: CONTRIBUYENTES_GET_BUSQUEDA,
  payload: { jsonparameters },
})
export const getContribuyentesBusquedaSuccess = data => ({
  type: CONTRIBUYENTES_GET_BUSQUEDA_SUCCESS,
  payload: { data },
})
export const getContribuyentesBusquedaFail = error => ({
  type: CONTRIBUYENTES_GET_BUSQUEDA_FAIL,
  payload: error,
})

export const postContribuyentesCreate = jsonparameters => ({
  type: CONTRIBUYENTES_POST_CREATE,
  payload: { jsonparameters },
})
export const postContribuyentesCreateSuccess = response => ({
  type: CONTRIBUYENTES_POST_CREATE_SUCCESS,
  payload: { data: response.Datos, parametros: response.Parametros || null },
})
export const postContribuyentesCreateFail = error => ({
  type: CONTRIBUYENTES_POST_CREATE_FAIL,
  payload: error,
})

export const putContribuyentesUpdate = jsonparameters => ({
  type: CONTRIBUYENTES_PUT_UPDATE,
  payload: { jsonparameters },
})
export const putContribuyentesUpdateSuccess = data => ({
  type: CONTRIBUYENTES_PUT_UPDATE_SUCCESS,
  payload: { data },
})
export const putContribuyentesUpdateFail = error => ({
  type: CONTRIBUYENTES_PUT_UPDATE_FAIL,
  payload: error,
})

export const delContribuyentesDelete = jsonparameters => ({
  type: CONTRIBUYENTES_DEL_DELETE,
  payload: { jsonparameters },
})
export const delContribuyentesDeleteSuccess = data => ({
  type: CONTRIBUYENTES_DEL_DELETE_SUCCESS,
  payload: { data },
})
export const delContribuyentesDeleteFail = error => ({
  type: CONTRIBUYENTES_DEL_DELETE_FAIL,
  payload: error,
})
